module.exports = __webpack_public_path__ + "img/227.ec776746.jpg";